<template>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Contenuto" text="Contenuto"></localized-text>
        </label>
        <auto-textarea class="form-control" v-model="localValue.text"></auto-textarea>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { Options } from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import WithModel from '@/mixins/withModel';

@Options({})
export default class paragraphBlock extends Mixins(WithModel) {
    declare localValue: OM.ParagraphBlock;

    created(){
        if(!this.localValue.text){
            this.localValue.text = "";
        }
    }

    @Watch('localValue.isFullWidth')
    @Watch('localValue.marginBottom')
    @Watch('localValue.text')
    onTextChange(){
        this.localValue.htmlText = `
            <div class="paragraphBlock ${(!this.localValue.isFullWidth ? 'px-4' : '')} ${('mb-' + this.localValue.marginBottom)}">
                ${this.localValue.text}
            </div>
        `;
    }

}
</script>
